'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _create = require('@most/create');

var fromEagerPromise = function fromEagerPromise(f) {
  return (0, _create.create)(function (add, end, error) {
    var rawPromise = f();

    return rawPromise.then(function (data) {
      add(data);
      end();
    }, error);
  });
};

exports.default = fromEagerPromise;